import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopComponent } from '../top/top.component';
import { UpdateBannerComponent } from '../shared/update-banner/update-banner.component';

@Component({
  selector: 'app-portal-layout',
  standalone: true,
  imports: [RouterOutlet, TopComponent, UpdateBannerComponent],
  templateUrl: './portal-layout.component.html',
  styleUrls: ['./portal-layout.component.scss']
})
export class PortalLayoutComponent {}
